export default "__VITE_ASSET__8176d29d__"